import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import T from '../text';
import { Field } from 'formik';
import { Stack } from '@mui/material';

export const FormikDateView = ({ name, label, disabled, focused, className }) => (
  <Stack flex flexDirection="row">
    <LocalizationProvider dateAdapter={AdapterDateFnsJalali}>
      <Field
        name={name}
        render={({ field, form }) => (
          <DatePicker
            value={field.value ? new Date(field.value.toString()) : null}
            className={className}
            disabled={disabled}
            autoFocus={focused}
            label={<T>{label}</T>}
            onChange={(value) => form.setFieldValue(name, value ?? '')}
          />
        )}
      />
    </LocalizationProvider>
  </Stack>
);
